
export default
function convertBase64ToUint8Array(aBase64String): ArrayBuffer {
    let raw = /*window !== undefined ? window.atob(aBase64String) : */atob(aBase64String);
    let rawLength = raw.length;
    let array: Uint8Array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
    }
    return array.buffer;
}
